module.exports = require('./helpers/bundle-url').getBundleURL('l1An2') + "logo.c51670a8.svg";